import { render, staticRenderFns } from "./TheSection.vue?vue&type=template&id=04045fd4&scoped=true&"
import script from "./TheSection.vue?vue&type=script&lang=js&"
export * from "./TheSection.vue?vue&type=script&lang=js&"
import style0 from "./TheSection.vue?vue&type=style&index=0&id=04045fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04045fd4",
  null
  
)

export default component.exports